// app/frontend/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Auth guard
let authChecked = false

router.beforeEach(async (to, from, next) => {
  const { useAuthStore } = await import('../stores/auth')
  const authStore = useAuthStore()

  // Check auth once on first navigation
  if (!authChecked) {
    await authStore.checkAuth()
    authChecked = true
  }

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next({ name: 'login' })
  } else if (to.meta.guest && authStore.isAuthenticated) {
    next({ name: 'lobby' })
  } else {
    next()
  }
})

export default router
